import { useBlobFile } from '@/hooks';
import { Fm1_01DefaultInfoUnitSelectors, useAppSelector } from '@/stores';
import { MyPageSelectors } from '@/stores/my-page';
import { cn } from '@/utils';
import { memo } from 'react';

export type CachetFormProps = {
	className?: string;
};

const CachetForm = ({ className }: CachetFormProps) => {
	const defaultInfoUnitDetail = useAppSelector(
		Fm1_01DefaultInfoUnitSelectors.selectDefaultInfoUnitDetail
	);

	const { unitCompanySealFilePath } = useAppSelector(
		MyPageSelectors.selectDataMyPage
	);

	const { filePath } = useBlobFile(
		defaultInfoUnitDetail?.fileList?.[0]?.path || unitCompanySealFilePath,
		'base64'
	);

	return (
		<div className={cn('w-[100px] h-[100px] bg-transparent', className)}>
			{filePath && (
				<img
					src={filePath || ''}
					alt="input file"
					className="w-full h-full object-contain"
				/>
			)}
		</div>
	);
};

export default memo(CachetForm);
